import { render, staticRenderFns } from "./RecadoListDialog.vue?vue&type=template&id=ee97601e&scoped=true"
import script from "./RecadoListDialog.vue?vue&type=script&lang=js"
export * from "./RecadoListDialog.vue?vue&type=script&lang=js"
import style0 from "./RecadoListDialog.vue?vue&type=style&index=0&id=ee97601e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee97601e",
  null
  
)

export default component.exports